import * as React from 'react';
import { GenericInfoContainer } from 'components/GenericInfoContainer';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { compose } from 'recompose';
import * as searchIcon from 'static/svg/search.svg';
import b_ from 'b_';
import './styles.scss';

interface IProps {
  handler: () => void;
}

const b = b_.with('stock-search-no-result');

type Enhanced = IProps & InjectedTranslateProps;

const enhance = compose<Enhanced, IProps>(translate);

const StockSearchNoResultRaw: React.FC<Enhanced> = ({ handler, t }) => {
  return (
    <GenericInfoContainer
      icon={<img src={searchIcon} alt="<>" />}
      title={t('Nothing was found')}
      subtitle={t('There was no idea of with the given parameters')}
      control={
        <button className={b('btn')} onClick={handler}>
          {t('Reset all parameters')}
        </button>
      }
    />
  );
};

export const StockSearchNoResult = enhance(StockSearchNoResultRaw);
